/* @flow */

import * as React from 'react';
import './modal-title.css';

type Props = {
    children?: React.Node,
    as: string,
};

ModalTitle.defaultProps = {
    as: 'div',
};

export function ModalTitle({children, as: Tag}: Props) {
    return <Tag styleName='modal-title'>{children}</Tag>;
}
